import { DashboardT } from 'business/definitions';
import { normalizeString } from 'helpers/helpers';

// TODO remove also accents et special chars
export const checkStringMatch = (
    string: string,
    filterString: string,
): boolean => normalizeString(string).includes(normalizeString(filterString));

export const filterDashboardByTitle = (
    dashboard: DashboardT,
    filterString: string,
): DashboardT | null =>
    checkStringMatch(dashboard.title, filterString) ? dashboard : null;

// FIXME: rename this function, name confusing with filterDashboardByTitle
export const filterDashboardsByTitle = (
    dashboards: DashboardT[],
    filterString: string,
    filterFunction: string[],
): DashboardT[] => {
    const dashboardsWithCorrectTag =
        filterFunction.length === 0 // If there is no filter, we don't filter
            ? dashboards
            : dashboards.filter((dashboard) =>
                  dashboard.tags.some((tag) => filterFunction.includes(tag)),
              );
    // We return them all when we have an empty string as search
    if (!filterString) return dashboardsWithCorrectTag;

    return dashboardsWithCorrectTag
        .map((dashboard) => filterDashboardByTitle(dashboard, filterString))
        .filter((dashboard) => dashboard != null) as DashboardT[];
};
